/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  'use strict';

  /**
   * Avada Order Limits - Multiple quantity helpers
   * Handles condition.isMultiple rules for ATC & cart quantity changes
   */
  const AvadaOrderLimitMultiple = {
    getMultipleRule: function(variantId) {
      const helper = window.AVADA_ORDER_LIMIT_HELPER;
      if (!helper || typeof helper.getRulesByVariantId !== 'function') return null;
      const rules = helper.getRulesByVariantId(variantId);
      if (!rules || !rules.length) return null;
      return rules.find(function(r) {
        return r.condition && r.condition.isMultiple && r.condition.multiple;
      }) || null;
    },

    normalizeQuantity: function(qty, rule) {
      if (!rule) return qty;
      const multiple = rule.condition.multiple;
      const max = rule.condition.max || Infinity;
      const parsed = parseInt(qty, 10);
      if (isNaN(parsed) || parsed < 0) return 0;
      let valid = Math.round(parsed / multiple) * multiple;
      if (valid < multiple && parsed > 0) valid = multiple;
      return Math.min(valid, max);
    }
  };

  const capture = true;

  // Quick View ATC: Always add by multiple
  document.addEventListener('theme:cart:add', function(e) {
    const button = e.detail && e.detail.button;
    const form = button && button.closest('form');
    if (!form) return;

    const isQuickView = button.closest('[data-quick-add-holder]') ||
      button.closest('[data-quick-add-modal]') ||
      button.closest('.product-upsell');
    if (!isQuickView) return;

    const variantId = (form.querySelector('input[name="id"]') || {}).value;
    if (!variantId) return;

    const rule = AvadaOrderLimitMultiple.getMultipleRule(variantId);
    if (!rule) return;

    const multiple = rule.condition.multiple;
    const input = form.querySelector('input[name="quantity"]');
    if (input) {
      input.value = multiple;
    } else {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.value = multiple;
      form.appendChild(hidden);
    }
  }, capture);

  // Cart drawer +/-: Increment/decrement by multiple
  document.addEventListener('click', function(e) {
    const btn = e.target.closest && e.target.closest('.cart__quantity-plus, .cart__quantity-minus');
    if (!btn) return;

    const counter = btn.closest('quantity-counter, .cart__quantity-counter');
    const item = counter && counter.closest('[data-item][data-variant-id]');
    if (!item) return;

    const rule = AvadaOrderLimitMultiple.getMultipleRule(item.getAttribute('data-variant-id'));
    if (!rule) return;

    const input = counter.querySelector('input[name="updates[]"]');
    if (!input) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const multiple = rule.condition.multiple;
    const max = rule.condition.max || Infinity;
    const qty = parseInt(input.value, 10) || 0;
    const newQty = btn.classList.contains('cart__quantity-plus')
      ? Math.min(qty + multiple, max)
      : Math.max(qty - multiple, 0);

    input.value = newQty;
    counter.dispatchEvent(new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: { id: input.dataset.id, quantity: String(newQty) }
    }));
  }, capture);

  // Cart drawer input change: Round quantity to multiple
  document.addEventListener('theme:cart:update', function(e) {
    const counter = e.target;
    const item = counter.closest && counter.closest('[data-item][data-variant-id]');
    if (!item) return;

    const rule = AvadaOrderLimitMultiple.getMultipleRule(item.getAttribute('data-variant-id'));
    if (!rule) return;

    const qty = parseInt(e.detail.quantity, 10);
    const validQty = AvadaOrderLimitMultiple.normalizeQuantity(qty, rule);
    if (validQty === qty) return;

    e.detail.quantity = String(validQty);
    const input = counter.querySelector('input[name="updates[]"]');
    if (input) input.value = validQty;
  }, capture);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
